var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuality(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    viewBox: "0 0 24 24",
    id: "quality-4",
    "data-name": "Line Color",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon line-color",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "secondary",
    points: "12 8.25 11.38 9.4 10 9.59 11 10.48 10.76 11.75 12 11.15 13.24 11.75 13 10.48 14 9.59 12.62 9.4 12 8.25",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "primary",
    points: "5.79 13.57 3 17.56 6.03 18.46 7.91 21 10.79 16.89",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "primary-2",
    "data-name": "primary",
    points: "18.21 13.57 21 17.56 17.97 18.46 16.09 21 13.21 16.89",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "primary-3",
    "data-name": "primary",
    cx: 12,
    cy: 10,
    r: 7,
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuality);
export default __webpack_public_path__ + "static/media/quality.f1872864f99a10b6f0680d795101a3b2.svg";
export { ForwardRef as ReactComponent };